import React from 'react';
export function TwoPathsSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-330">
      <div className="max-w-5xl mx-auto" data-id="element-331">
        <h2 className="text-3xl md:text-4xl font-bold font-serif text-center text-gray-900 mb-8" data-id="element-332">
          Tienes dos caminos
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-333">
          {/* Camino A */}
          <div className="bg-gray-100 border-2 border-gray-200 rounded-[20px] p-8 text-center flex flex-col items-center justify-center opacity-80" data-id="element-334">
            <div className="w-12 h-12 bg-gray-300 text-gray-600 rounded-full flex items-center justify-center font-bold text-xl mb-6" data-id="element-335">
              A
            </div>
            <p className="text-gray-500 text-lg font-medium leading-relaxed" data-id="element-336">
              Seguir intentando adivinar qué le pasa a tu perro, cargando el
              dolor del hombro un día más.
            </p>
          </div>

          {/* Camino B */}
          <div className="bg-brand-teal border-4 border-brand-gold rounded-[20px] p-8 text-center flex flex-col items-center justify-center shadow-2xl transform md:scale-105" data-id="element-337">
            <div className="w-12 h-12 bg-brand-gold text-gray-900 rounded-full flex items-center justify-center font-bold text-xl mb-6 shadow-lg" data-id="element-338">
              B
            </div>
            <p className="text-white text-xl font-bold leading-relaxed" data-id="element-339">
              Invertir $9.95 y permitir que esta guía sea el mapa para recuperar
              la paz mañana mismo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}